import { notFound } from "@tanstack/react-router";
import { setContentResponseStatus } from "#/_packages/umbrella/features/routing/utils/response-status";

// These documents provide content for FAQ blocks, not standalone public pages.
export async function rejectStandaloneFaqPage(contentType: string | undefined) {
	if (contentType !== "faqPage" && contentType !== "faqsPages") return;
	await setContentResponseStatus(404);
	throw notFound();
}

export function excludeFaqPagesFromSitemap(xml: string) {
	// The CMS sitemap uses unprefixed <url>/<loc> elements in the default namespace.
	return xml.replace(/<url(?:\s[^>]*)?>[\s\S]*?<\/url>/g, (entry) => {
		const loc = entry.match(/<loc>([^<]*)<\/loc>/)?.[1]?.trim();
		if (!loc) return entry;
		try {
			const pathname = new URL(loc).pathname;
			return pathname === "/faq" || pathname.startsWith("/faq/") ? "" : entry;
		} catch {
			return entry;
		}
	});
}
